export default __webpack_public_path__ + "static/img-platform-explain--mobile-19e52da0b88dc21fb7dc18b2211b92db.png";